import React from "react";

import GridBarFiltersAtomCheckbox from "@/components/Grid/Bar/Filters/Atom/Checkbox";
import LayoutSidebarFiltersAtomHeader from "@/components/Grid/Bar/Filters/Atom/Header";

export default function LayoutSidebarFiltersRewards() {
  return (
    <LayoutSidebarFiltersAtomHeader name="vaults_with_rewards" title="Rewards" hideCount>
      <GridBarFiltersAtomCheckbox filter="vaults_with_rewards" label="Only show vaults with rewards" />
    </LayoutSidebarFiltersAtomHeader>
  );
}
